import axios from './api';

export const getPlanDetail = (params: any) => (
  axios.request({
    method: 'GET',
    url: '/hourapp//getPlanDetailList',
    params,
  })
);

export const postAdd = (data: any) => (
  axios.request({
    method: 'POST',
    url: '/hourapp/addPlanHour',
    data,
  })
);

export const getUserSelectPlanList = (params:any) => (
  axios.request({
    method: 'GET',
    url: '/hourapp/getUserSelectPlanList',
    params,
  })
);
